import { IconWell } from '@playbooks/molecules/icons/icon-well';
import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';

export const ModalAvatar = ({ icon, thumbnail, title, text, badges }) => {
	// Render
	return (
		<Avatar className='flex-between w-full'>
			<span className='flex-start gap-4'>
				{thumbnail ? <AvatarImage src={thumbnail} alt={title} size='xs' /> : <IconWell icon={icon} size='sm' />}
				<AvatarContent className='group-hover:underline'>
					<AvatarDescription>{title}</AvatarDescription>
				</AvatarContent>
			</span>
			{badges}
		</Avatar>
	);
};
